module.exports = __webpack_public_path__ + "img/m-banner-vbrohihj-pt-PT.48dac1db.jpg";